function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "14",
  height: "12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12 2.667H1.333C.597 2.667 0 3.263 0 4v6.667C0 11.403.597 12 1.333 12H12c.737 0 1.333-.597 1.333-1.333V4c0-.737-.596-1.333-1.333-1.333zm0 8H1.333V4H12v6.667zM10 0H3.333C2.597 0 2 .597 2 1.333h9.333C11.333.597 10.737 0 10 0z",
  fill: "#000"
})));